/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getContextualSuggestedActions} from '../api'

 export const useQueryGetContextualSuggestedActions = createReactQueryHook('getContextualSuggestedActions', getContextualSuggestedActions)
